import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ButtonTypeAttributeEnum } from '@hrra/ui';
import { ButtonTypeEnum } from '@hrra/ui';
import { cancelBlacklistChanges, loadJobseekerBlacklist, removeSelectedBlacklistItem, selectBlackListItem, updateJobseekerBlacklist } from 'src/app/root-store/jobseeker-store/jobseeker-settings/actions';
import { searchedCustomerList, selectCurrentBlacklist, selectCustomerList, selectJobseekerIgnoredCustomerList } from 'src/app/root-store/jobseeker-store/jobseeker-settings/selectors';
import { AppState } from 'src/app/root-store/state';
import { JobseekerBlacklistUpdateViewModel } from '../shared/services/jobseeker-settings.service';
import { BasicOptionItem } from '@hrra/common-models';

@Component({
    selector: 'app-jobseeker-settings-blacklist',
    templateUrl: './redesign/jobseeker-settings-blacklist.component.html',
    styleUrls: ['./redesign/jobseeker-settings-blacklist.component.scss'],
    standalone: false
})
export class JobseekerSettingsBlacklistComponent implements OnInit, AfterViewInit {

  @ViewChild('text') textElement: ElementRef;
  @ViewChild('selectedCustomers') selectedCustomersElement: ElementRef;
  customerListHeight: number;

  public customerListMaxSize = 1023;
  public customerListMinSize = 1024;

  public buttonAttributeType: any;

  customerList$: Observable<BasicOptionItem[]>;
  jobseekerIgnoredCustomerList$: Observable<BasicOptionItem[]>;
  currentBlacklist$: Observable<JobseekerBlacklistUpdateViewModel>;

  public buttonType: any;

  constructor(private store: Store<AppState>) {
    this.buttonType = ButtonTypeEnum;
    this.buttonAttributeType = ButtonTypeAttributeEnum;
   }

  ngAfterViewInit(): void {
    setTimeout(() => this.updateCustomerHeight(), 1000);
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.store.dispatch(loadJobseekerBlacklist({ payload: { name: null }}));
    }, 0);

    this.customerList$ = this.store.pipe(select(selectCustomerList));
    this.jobseekerIgnoredCustomerList$ = this.store.pipe(select(selectJobseekerIgnoredCustomerList));
    this.currentBlacklist$ = this.store.pipe(select(selectCurrentBlacklist));
  }

  onCustomerSearchChange(searchValue: string): void {
    searchValue = searchValue.trim();
    this.store.dispatch(loadJobseekerBlacklist({ payload: {name: searchValue} }));
  }

  onSelectCustomer(customer) {
    this.store.dispatch(selectBlackListItem({ payload: { customer: customer } }));

    this.updateCustomerHeight();
  }

  removeSelectedCustomer(customer) {
    this.store.dispatch(removeSelectedBlacklistItem({ payload: { customer: customer } }));

    this.updateCustomerHeight();
  }

  onSave(data) {
    this.store.dispatch(updateJobseekerBlacklist({ payload: data }));
  }

  onCancel() {
    this.store.dispatch(cancelBlacklistChanges());

    this.updateCustomerHeight();
  }

  updateCustomerHeight() {
    setTimeout(() => {
      let selectedCustomersHeight = this.selectedCustomersElement.nativeElement.offsetHeight;
      let textHeight = this.textElement.nativeElement.offsetHeight;
      this.customerListHeight = selectedCustomersHeight + textHeight;
    }, 0);
  }
}
